import { Container, decorate, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import ILoader from "../../loader/Iloader";
import IApp from "../IApp";
import InitPixiApp from "./InitPixiApp";
import IInitApp from "../IInitApp";
import PixiAudio from "./PixiAudio";
import PixiLoader from "./PixiLoader";
import ISymbols from "./ISymbols";
import PixiSymbols from "./PixiSymbols";
import PixiApp from "./PixiApp";
import PixiLayers from "./PixiLayers";
import * as PIXI from "pixi.js-legacy";
import EventEmitter = PIXI.utils.EventEmitter;
import IAudio from "../IAudio";
import PixiEngine from "./PixiEngine";
import IEngine from "../IEngine";
import EngineDebug from "../EngineDebug";
import PixiDebug from "./PixiDebug";
import IBootConfig from "../../boot/IBootConfig";
import AbstractInfoPages from "../AbstractInfoPages";
import PixiInfoPages from "./PixiInfoPages";
import AbstractIframePage from "../AbstractIfarmePage";
import IframeParagraphPage from "../IframeParagraphPage";
import IframeHistory from "../IframeHistory";
import IInfoPages from "../IInfoPages";

export function defineEngine(container: Container, config?: IBootConfig) {
	decorate(injectable(), PIXI.Container);
	decorate(injectable(), PIXI.DisplayObject);
	decorate(injectable(), EventEmitter);

	container
		.bind<IEngine>(SERVICE_IDENTIFIER.Engine)
		.to(PixiEngine)
		.inSingletonScope();
	container
		.bind<EngineDebug>(SERVICE_IDENTIFIER.EngineDebug)
		.to(PixiDebug)
		.inSingletonScope();
	container
		.bind<IAudio>(SERVICE_IDENTIFIER.EngineAudio)
		.to(PixiAudio)
		.inSingletonScope();
	container
		.bind<ILoader>(SERVICE_IDENTIFIER.EngineLoader)
		.to((config && config.EngineLoader) || PixiLoader)
		.inSingletonScope();
	container
		.bind<PixiLayers>(SERVICE_IDENTIFIER.EngineAppLayers)
		.to((config && config.EngineAppLayers) || PixiLayers)
		.inSingletonScope();

	container
		.bind<ISymbols>(SERVICE_IDENTIFIER.EngineAppSymbols)
		.to((config && config.EngineAppSymbols) || PixiSymbols)
		.inSingletonScope();
	container
		.bind(SERVICE_IDENTIFIER.InfoPages)
		.to((config && config.InfoPages) || PixiInfoPages)
		.inSingletonScope();
	container
		.bind<AbstractIframePage>(SERVICE_IDENTIFIER.ParagraphPage)
		.to(IframeParagraphPage)
		.inSingletonScope();
	container
		.bind<AbstractIframePage>(SERVICE_IDENTIFIER.History)
		.to(IframeHistory)
		.inSingletonScope();

	container
		.bind<IApp>(SERVICE_IDENTIFIER.EngineApp)
		.to((config && config.EngineApp) || PixiApp)
		.inSingletonScope();
	container
		.bind<IInitApp>(SERVICE_IDENTIFIER.EngineAppInit)
		.to(InitPixiApp)
		.inSingletonScope();
}
